import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}

const ServiceDownBanner = ({ className, message }) => {
    return (
        <>
            <div className={className}>
                <span className="icon-error" /> {message}
            </div>
        </>
        )
}

ServiceDownBanner.propTypes = propTypes;
export default ServiceDownBanner;